import { render } from "./BoxNovaMais.vue?vue&type=template&id=9d545ea2"
import script from "./BoxNovaMais.vue?vue&type=script&lang=js"
export * from "./BoxNovaMais.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__